<template>
    <x-page title="Add Validation Rules">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <validation-rule-form id="validation-rule-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors" />
        <template #footer>
            <x-submit-button form="validation-rule-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleValidationXhrError } from '../../helpers'
import ValidationRuleForm from './ValidationRuleForm.vue'

export default {
    components: {
        ValidationRuleForm,
        XPage,
        XBackButton,
        XSubmitButton,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/validation-rules`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} added!`,
                    })
                    this.$router.push('/admin/validation-rules')
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
}
</script>